/*  */
import _ from 'lodash';
import errorLogger from 'utils/errorLogger';
import Config from 'Config';

const GOOGLE_PLATFORM_JS = 'https://apis.google.com/js/client:platform.js';

// @ts-expect-error ts-migrate(7034) FIXME: Variable 'loadId' implicitly has type 'any' in som... Remove this comment to see the full error message
let loadId = null;

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'callback' implicitly has an 'any' type.
function load(callback) {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'gapi' does not exist on type 'Window & t... Remove this comment to see the full error message
  if (window.gapi) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'gapi' does not exist on type 'Window & t... Remove this comment to see the full error message
    callback(window.gapi);
    return;
  }

  const $script = require('scriptjs');

  // @ts-expect-error ts-migrate(7005) FIXME: Variable 'loadId' implicitly has an 'any' type.
  if (!loadId) {
    $script(GOOGLE_PLATFORM_JS, (loadId = _.uniqueId('gapi')));
  }

  // @ts-expect-error ts-migrate(7005) FIXME: Variable 'loadId' implicitly has an 'any' type.
  $script.ready(loadId, function () {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'gapi' does not exist on type 'Window & t... Remove this comment to see the full error message
    callback(window.gapi);
  });
}

/**
 * Initializes the Google API with an auth2 instance.
 * For more information, see: https://developers.google.com/identity/sign-in/web/reference
 */
function initWithAuthInstance(callback = function () {}) {
  const clientId = Config.Environment.GOOGLE_OAUTH_CLIENT_ID;
  if (!clientId) {
    throw new Error('Missing GOOGLE_OAUTH_CLIENT_ID');
  }
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'gapi' implicitly has an 'any' type.
  load(function (gapi) {
    gapi.load('auth2', function () {
      let auth2 = gapi.auth2.getAuthInstance();
      if (!auth2) {
        auth2 = gapi.auth2.init({
          client_id: clientId,
          scope: 'https://www.googleapis.com/auth/plus.login',
          cookiepolicy: 'single_host_origin',
        });
      }
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
      callback(gapi);
    });
  });
}

/**
 * Fetches an authorization code for server-side authentication.
 * See https://developers.google.com/identity/sign-in/web/server-side-flow
 * @returns {Promise} that resolves with an authorization code
 */
function fetchAuthorizationCode() {
  return new Promise(function (resolve, reject) {
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'authResult' implicitly has an 'any' typ... Remove this comment to see the full error message
    const handleAuthResult = function (authResult) {
      const { code } = authResult;
      if (code) {
        resolve(code);
      } else {
        console.warn(authResult.error);
        reject(new Error('GoogleAPI auth fetchAuthorizationCode failed'));
      }
    };

    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '(gapi: any) => void' is not assi... Remove this comment to see the full error message
    initWithAuthInstance(function (gapi) {
      const auth2 = gapi.auth2.getAuthInstance();
      auth2
        .grantOfflineAccess({ redirect_uri: 'postmessage', prompt: 'select_account' })
        .then(handleAuthResult)
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'e' implicitly has an 'any' type.
        .catch((e) => {
          console.warn(e.message);
          errorLogger('GoogleAPI fetchAuthorizationCode failed');
        });
    });
  });
}

/**
 * Signs out of the Google API auth2 instance
 */
function signOut() {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '(gapi: any) => void' is not assi... Remove this comment to see the full error message
  initWithAuthInstance(function (gapi) {
    const auth2 = gapi.auth2.getAuthInstance();
    if (auth2.isSignedIn.get()) {
      auth2.signOut();
    }
  });
}

export default {
  initWithAuthInstance,
  fetchAuthorizationCode,
  signOut,
};
